app-speedbump {

    .speedbump {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        width: 100%;
        height: 100vh;
        z-index: 100;
        top: 0;
        left: 0;
        animation: speedbumpIn 250ms linear forwards;

        &__overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, .7);
        }

        &__inner {
            position: absolute;
            width: 90%;
            max-width: 680px;
            background: #fff;
            @include paddings(40,40,40,40);
            text-align: left;

            .label {
                font-family: $font-family-primary-bold;
                @include text-size(16);
                @include line-height(24);
                @include margin-direction(bottom, 16);
            }

            .headline {
                font-family: $font-family-primary-bold;
                @include text-size(32);
                @include line-height(40);
                @include margin-direction(bottom, 24);
            }
        }

        &__message {
            @include margin-direction(bottom, 32);

            p {
                color: $gray-dark;
                @include text-size(16);
                @include line-height(24);
            }

            a {
                @include text-size(16);
            }

            strong {
                font-family: $font-family-primary-bold;
            }
        }

        &__actions {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .close-frame {
                position: absolute;
                top: 0;
                right: 0;
                width: 30px;
                height: 30px;
                color: $white;
                padding: 0;
                border: none;
                background: #fff;
                @include transitionDefault(all);

                svg {
                    @include svg-format(30px, 30px, $gray-dark);
                }

                &:hover {
                    opacity: .85;
                }

                @include focus-visible-box-shadow(0 0 0 2px rgba($white, .75));

                &.close-frame-bottom {
                    width: auto;
                }
            }

            a {
                &.btn.btn-primary {
                    margin-bottom: 0;
                }

                &.arrow-link__underline {
                    color: $gray-dark;
                    @include margin-direction(left, 24);
                }
            }
        }
    }

    @keyframes speedbumpIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }




    @include media-breakpoint-down(md) {
        .speedbump {

            &__inner {
                @include paddings(48,24,48,24);
                text-align: center;

                .label {
                    @include text-size(14);
                    @include line-height(22);
                }

                .headline {
                    @include text-size(26);
                    @include line-height(34);
                }
            }

            &__message {

                p {
                    @include text-size(14);
                    @include line-height(22);
                }

                a {
                    @include text-size(14);
                }
            }


            &__actions {
                flex-direction: column;
                justify-content: center;

                a {

                    &.btn.btn-primary {
                        @include margin-direction(bottom, 24);
                        width: 100%;
                    }

                    &.arrow-link__underline {
                        margin-left: 0;
                    }
                }
            }
        }
    }
}